import { COUNTRY_OPTIONS } from 'intls/countries';
import { Idiom } from './intl';

export interface CountryOption {
  value: string;
  label: string;
}

export const getCountryOptions = (countryCodes: string[], language: Idiom) => {
  const countries = countryCodes.map(countryCode => {
    const options = COUNTRY_OPTIONS[language];

    const countryIndex = options.values.findIndex(
      country => country === countryCode
    );
    return {
      value: countryCode,
      label: countryIndex !== -1 ? options.labels[countryIndex] : undefined,
    };
  });

  // If label is undefined, country is not in the portal options list and it is not a
  //  valid option for AXA, remove it
  return countries
    .filter(country => country.label)
    .sort((a, b) => a.label!.localeCompare(b.label!)) as CountryOption[];
};
